import React, { FC } from 'react';
import { UseFieldArrayAppend } from 'react-hook-form';

import { AttachmentGroups } from 'buyside/components/presentation/IdeaForm/WriteupAndAttachments/writeupAndAttachments';
import AttachmentForm from 'buyside/components/presentation/IdeaForm/WriteupAndAttachments/Attachments/AttachmentForm/attachmentForm';
import ResearchFormWizardSection from 'buyside/components/presentation/ResearchFormWizard/researchFormWizardSection';
import Icon from 'buyside/components/presentation/Icon/icon';

import { IdeaFormInput } from 'buyside/util/researchSubmission';

import styles from './attachmentsStyles.scss';

const Attachments: FC<{
  append: UseFieldArrayAppend<IdeaFormInput, 'attachments'>;
  attachmentGroups: AttachmentGroups;
  thesisEditorHidden: boolean;
}> = ({ append, attachmentGroups, thesisEditorHidden }) => (
  <ResearchFormWizardSection title="Attachments">
    <div className={styles.attachmentGroups}>
      {Object.entries(attachmentGroups).map(
        ([researchType, { description, icon, attachmentPreviewIndices }]) => {
          const isFormattedThesisGroup = researchType === 'Formatted Thesis';

          if (isFormattedThesisGroup && thesisEditorHidden) return null;

          const attachmentPreviews = Object.values(attachmentPreviewIndices);

          return (
            <div key={`${researchType}-attachment-group`} className={styles.attachmentGroup}>
              <div>
                <p>
                  <Icon className={styles.attachmentGroupIcon} type={icon} />
                  <strong>{researchType}</strong>
                </p>
                <p>{description}</p>
              </div>
              <div className={styles.attachmentPreviews}>
                {attachmentPreviews}
                {(isFormattedThesisGroup && !attachmentPreviews.length) ||
                !isFormattedThesisGroup ? (
                  <AttachmentForm
                    onSubmitCallback={values => append(values)}
                    researchType={researchType}
                  />
                ) : null}
              </div>
            </div>
          );
        }
      )}
    </div>
  </ResearchFormWizardSection>
);

export default Attachments;
